export default {
	list: 'FMVStatementFootnote',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxPeriod: {
			class: "value",
			dataName: 'TaxPeriod',
			type: 'string',
			title: 'Tax Period',
			width: 80,
			hidden: false,
			readOnly: false
		},
		Page: {
			class: 'value',
			dataName: 'Page',
			type: 'string',
			title: 'Page',
			width: 80,
			hidden: false,
			readOnly: false
		},
		TagNumber: {
			class: "value",
			dataName: 'TagNumber',
			type: 'string',
			title: 'Tag Number',
			width: 100,
			hidden: false,
			readOnly: false
		},
		TagLocation: {
			class: 'value',
			dataName: 'TagLocation',
			type: 'string',
			title: 'Tag Location',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Column: {
			class: 'choice',
			dataName: 'Column',
			type: 'string',
			title: 'Column',
			width: 150,
			hidden: false,
			readOnly: false
		},
		InvestmentId: {
			class: 'lookup',
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		Investments: {
			class: "choice",
			dataName: 'Investments',
			type: 'string',
			title: 'Investments',
			width: 150,
			hidden: false,
			readOnly: false
		},
		InvestmentGroup: {
			class: "choice",
			dataName: 'InvestmentGroup',
			type: 'string',
			title: 'Investment Group',
			width: 150,
			hidden: false,
			readOnly: false
		},
		InvestmentTitle: {
			class: 'lookup',
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment',
			width: 150,
			hidden: true,
			readOnly: true
		},
		FootnoteId: {
			class: 'lookup',
			dataName: 'FootnoteId',
			type: 'number',
			title: 'FootnoteId',
			width: 100,
			hidden: true,
			readOnly: false
		},
		FootnoteFootnoteID: {
			class: 'lookup',
			dataName: 'Footnote/FootnoteID',
			type: 'string',
			title: 'Footnote ID',
			width: 100,
			hidden: true,
			readOnly: true
		},
		Footnote: {
			class: "value",
			dataName: 'Footnote',
			type: 'string',
			title: 'Footnote',
			width: 350,
			hidden: false,
			readOnly: true
		},

	}
}